import { IAuthorization } from "Common/Interfaces";
import { createContext } from "react";

interface AuthContextType {
  authDetails: IAuthorization | undefined;
  isLoadingAuthorization: boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
